<div class="detalhe__container">
  <div class="geral__experiencia__detalhe">
    <div class="experiencia__caixa__descricao">
      <div
        class="experiencia__card"
        *ngIf="
          membro !== undefined && !carregandoMembro && !carregandoExperiencia
        "
      >
        <app-detalhes-experiencia
          [idExperiencia]="experiencia.id"
          [cpfMembro]="membro.cpf"
          [membroCacaus]="membro.saldo.saldoPontos"
          [idExperienciaParceiro]="experiencia.experienciaParceiro[0].id"
          [imagemSrc]="experiencia.imagemSrc"
          [nome]="experiencia.nome"
          [descricao]="experiencia.descricao"
          [niveis]="experiencia.experienciaNiveis"
          [parceirosLogoSrc]="[
            experiencia.experienciaParceiro[0].parceiro.imagemSrc
          ]"
          [quantidadeDisponivel]="experiencia.quantidadeDisponivel"
          [pontuacao]="experiencia.precoEmCacaus"
          [quantidadePorMembro]="experiencia.quantidadeMembro"
          (abrirLocaisDisponiveis)="abrirPopupLocaisDisponiveis(true)"
          [lotes]="experiencia.experienciaLotes"
          [selecionaLocal]="experiencia.selecionaLocal"
          [loteCustomizado]="experiencia.loteCustomizado"
          [tag]="experiencia.tag"
          [parceiroId]="experiencia.experienciaParceiro[0]?.parceiro?.id!"
          [quantidadeAcompanhantes]="experiencia.quantidadeAcompanhantes"
          [mensagemResgate]="this.obterMensagemResgate()"
          [membro]="membro"
          [possuiQuantidadeLoteAtual]="experiencia.possuiQuantidadeLoteAtual"
          [dataProximoLoteDisponivel]="experiencia.dataProximoLoteDisponivel"
        >
          [experiencia]="experiencia"
        </app-detalhes-experiencia>
      </div>

      <ngx-skeleton-loader
        *ngIf="carregandoExperiencia || carregandoMembro"
        count="1"
        [theme]="{
          'border-radius': '24px',
          width: '100%',
          height: '336px',
          margin: '0 0 64px 0'
        }"
      ></ngx-skeleton-loader>

      <div
        class="experiencia__descricao"
        *ngIf="!carregandoDescricao"
        [ngClass]="{ experiencia__detalhe_com_video: experiencia.videoUrl }"
      >
        <div
          class="descricao__topicos"
          *ngIf="this.mecanicaResgate != undefined"
        >
          <div class="titulo__mecanica">
            <img
              class="icone__mecanica"
              src="assets/images/icons/ticket-branco.png"
            />
            <p class="texto__mecanica">Mecânica de Resgate</p>
          </div>

          <div class="container__topicos">
            <div class="topico">
              <div
                class="lista__topicos"
                *ngFor="
                  let descricaoValor of mecanicaResgate;
                  let i = index;
                  let l = last
                "
              >
                <div class="descricao">
                  <p class="numero__topico">{{ i + 1 }}</p>
                  <p class="texto__topico">
                    {{ descricaoValor }}
                  </p>
                </div>
                <div class="barra__topico" *ngIf="!l"></div>
              </div>
            </div>
          </div>

          <div class="container__mensagem__validade">
            <p
              class="mensagem__validade"
              *ngIf="experiencia.prazoEmDias > 0 || mensagemVazia != null"
            >
              <span *ngIf="experiencia.prazoEmDias != 0"
                >Validade: Esta experiência tem validade de
                {{ experiencia.prazoEmDias }} dias após o resgate.</span
              >
              <span *ngIf="mensagemVazia != null">{{
                experiencia.mensagemValidade
              }}</span>
            </p>
          </div>
        </div>

        <div class="div__img_parceiro__mobile">
          <img
            class="imagem__parceiro__mobile"
            [src]="experiencia?.experienciaParceiro[0].parceiro.imagemSrc"
          />
        </div>

        <div *ngIf="experiencia?.videoUrl" class="video_player">
          <iframe
            [src]="experiencia.videoUrl | safe"
            id="lovers-video-player"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen
          ></iframe>
        </div>

        <div
          class="descricao__adicional"
          [ngClass]="{ descricao__adicional_full: experiencia.videoUrl }"
        >
          <img
            class="imagem__parceiro"
            [src]="experiencia?.experienciaParceiro[0].parceiro.imagemSrc"
          />

          <div class="topicos__adicionais">
            <p
              class="mensagem__validade__mobile"
              *ngIf="experiencia.prazoEmDias > 0 || mensagemVazia != null"
            >
              <span *ngIf="experiencia.prazoEmDias != 0"
                >Validade: Esta experiência tem validade de
                {{ experiencia.prazoEmDias }} dias após o resgate.</span
              >

              <span *ngIf="mensagemVazia != null">{{
                experiencia.mensagemValidade
              }}</span>
            </p>

            <p class="titulo__topico">
              <img src="assets/images/icons/observacao.png" /> Outras
              Observações
            </p>

            <div *ngFor="let texto of observacoes">
              <p class="texto__titulo">{{ texto.titulo }}</p>

              <div *ngFor="let descricao of texto.experienciaParagrafo">
                <ul class="texto__topico">
                  <li>{{ descricao.descricao }}</li>
                </ul>
              </div>
            </div>

            <div *ngIf="existeDetalhamentoMomentoEspecial">
              <div
                [innerHtml]="experiencia.detalhamentoMomentoEspecial | linkify"
              ></div>
            </div>
          </div>
        </div>
      </div>

      <ngx-skeleton-loader
        *ngIf="carregandoDescricao"
        count="1"
        [theme]="{
          'border-radius': '15px',
          width: '100%',
          height: '50px',
          margin: '0 0 30px 0'
        }"
      ></ngx-skeleton-loader>

      <ngx-skeleton-loader
        class="detalhes__experiencia--loader"
        *ngIf="carregandoDescricao"
        count="6"
        [theme]="{
          'border-radius': '15px',
          width: '100%',
          height: '40px',
          margin: '0 0 10px 0'
        }"
      ></ngx-skeleton-loader>

      <div class="detalhes__validade" *ngIf="!carregandoDescricao">
        <p class="mensagem__info">
          Para mais informações sobre o programa Cacau Lovers, acesse o nosso
          <a class="info__link" [routerLink]="'/ajuda/cacaulovers'">FAQ</a> e
          termos e condições em nosso
          <a class="info__link" (click)="mostrarPopupRegulamentos()"
            >REGULAMENTOS</a
          >.
        </p>
      </div>

      <div class="experiencia__regras__resgate">
        <lovers-accordion
          class="lovers__accordion"
          titulo="Regras de Resgate"
          tamanhoTitulo="grande"
        >
          <p class="regras__resgate" *ngFor="let regra of regrasResgate">
            {{ regra }}
          </p>
        </lovers-accordion>
      </div>
    </div>
  </div>
</div>

<!-- Modal Generico -->
<lovers-popup
  [exibir]="exibePopupGenerico"
  (onClose)="exibePopupGenerico = false"
  tamanho="grande"
>
  <div class="popup__header">
    <p class="header__title">{{ tituloModalGenerico }}</p>
  </div>
  <div class="popup__body">
    <div class="descricao">
      <label class="mb-0">
        <span *ngFor="let item of descricaoModalGenerico" [innerHtml]="item">
        </span>
      </label>
    </div>
  </div>
</lovers-popup>

<!-- Modal Google maps -->
<app-localizacao
  *ngIf="experiencia !== undefined"
  [exibirModal]="exibirModalLocalizacao"
  (fecharCardLocalizacao)="abrirPopupLocaisDisponiveis(false)"
  [imagemParceiro]="experiencia.experienciaParceiro[0].parceiro.imagemSrc"
  [idExperiencia]="experiencia?.id"
>
</app-localizacao>
